module.exports = {
    common: {
        no_access: 'sorry, you have no access'
    },
    ChanceBoard: {
        department: 'department',
        sales_user_id: 'sales',
        query: 'query',
        Show_chance_distribution: 'Show chance distribution',
        Show_sales_funnel: 'Show sales funnel',
        chance_cnt: 'chance number',
        win_amount: 'win amount',
        win_number: 'win number',
        fail_number: 'fail number',
        level_rise: 'level rise',
        level_decline: 'level decline',
        follow_number: 'follow number',
        create_chance: 'create chance',
        created_in_30_days: 'created_in_30_days',
        no_follow_in_30_days: 'no_follow_in_30_days',
        no_follow_in_60_days: 'no_follow_in_60_days',
        no_level_up_30_days: 'no_level_up_30_days',
        has_quote_in_30_days: 'has_quote_in_30_days',
        has_contract_in_30_days: 'has_contract_in_30_days',
    },

    quote: {
        select_contacts: 'Select contacts',
        effective_to: 'Effective to',
        select_quotation_template: 'Quote template',
        preview_template: 'Preview Template',
        add_line: 'Add line',
        trade_name: 'Trade name',
        unit: 'unit',
        standard_price: 'Standard price',
        minimum_price: 'minimum price',
        tax_rate: 'tax rate',
        sales_price: 'Sales price',
        discount_ratio: 'percentage%',
        number: 'number',
        remark: 'Trade name remark',
        select_item: 'select trade name',
        quote_remark: 'quote remark',
        tax_amount: 'Tax amount',
        total_amount_including_tax: 'Total price',
        amount_not_taxed: 'Amount not taxed',
        template_extension_variable: 'Template extension variable',
        please_select: 'Please select',
        submit: 'Submit',
        price_tips: 'The current price is lower than the lowest price, which needs to be reviewed',
        template_preview: 'Template Preview',
        template_tips: 'Please select a template',
        get_failed: 'Get failed',
        failed_to_get_product_catalog: 'Failed to get product catalog',
        contact_cannot_be_empty: 'Contact cannot be empty',
        valid_until_cannot_be_empty: 'Valid until cannot be empty',
        commodity_data_cannot_be_empty: 'Commodity cannot be empty',
        quotation_template_cannot_be_empty: 'Quotation template cannot be empty',
        failed_to_get_quotation_template: 'Failed to get quotation template',
        failed_to_get_contact: 'Failed to get contact',
        failed_to_get_product: 'Failed to get product',
        quotation_data_cannot_be_empty: 'Quotation data cannot be empty',
        submission_failed: 'Submission failed',
        submitted_successfully: 'Submitted successfully',
        the: 'the',
        product_name_cannot_be_empty: 'Product name cannot be empty',
        unit_cannot_be_empty: 'Unit cannot be empty',
        market_price_cannot_be_empty: 'Market price cannot be empty',
        tax_rate_cannot_be_empty: 'Tax rate cannot be empty',
        sales_price_cannot_be_empty: 'Sales price cannot be empty',
        discount_ratio_cannot_be_empty: 'Discount ratio cannot be empty',
        cnt_cannot_be_empty: 'Cnt cannot be empty',
        select_quote_no: 'Select Quote No',
        quote_no_cannot_be_empty: 'Quote no cannot be empty'
    },
    contract: {
        contract_remark: 'Contract remark',
        select_contract_template: 'Contract template',
        contract_template_cannot_be_empty: 'Contract template cannot be empty',
    }

}